const HELPER_TEXTS = {
  PAGE_DESCRIPTION_TITLE: 'Página de cobertura express',
  PAGE_DESCRIPTION:
    'Analiza y gestiona todos los aspectos de cobertura express y programados de tu almacen desde esta página.'
};

export default HELPER_TEXTS;
